<template>
  <div class="batch-card-body">
    <p class="batch-card-body__title">
      <span
        :class="{
          'open': isOpen,
          'closed': isCompleted || isCollected
        }"
      >
        {{ batch?.total_samples }}
      </span>
    </p>

    <p class="batch-card-body__subtitle">
      {{ samplesLabel }}
    </p>

    <hr class="batch-card-body__separator">

    <div class="batch-card-body__description">
      <span
        :class="{
          'open': isOpen,
          'closed': isCompleted || isCollected
        }"
      >
        {{ stateName }}
      </span>
    </div>
  </div>
</template>

<script>
import strings from '@/strings'

export default {
  name: 'BatchCardBody',
  props: {
    batch: {
      type: Object,
      required: true
    }
  },
  computed: {
    stateName() {
      if (this.isCollected) {
        return 'Coletado'
      }

      return strings.batchStates[this.batch?.state]?.translatedState
    },
    isOpen() {
      return this.stateName === 'Aberto'
    },
    isCompleted() {
      return this.stateName === 'Completo'
    },
    isCollected() {
      return this.batch?.samplesCollected
    },
    samplesLabel() {
      return ['Amostras', 'Amostra'][this.batch?.total_samples] ?? 'Amostras'
    }
  }
}
</script>

<style lang="scss" scoped>
.batch-card-body {
  padding-top: 1rem;
  padding-bottom: 1rem;

  &__title {
    font-weight: 800;
    letter-spacing: -0.3px;
    padding-top: 1px;
    font-size: 2rem;
  }

  &__subtitle {
    padding-top: 0.25rem;
    font-size: 0.75rem;
    text-transform: uppercase;
    margin-bottom: 0.5rem;
  }

  &__separator {
    margin-bottom: 0.25rem;
  }

  &__description {
    font-size: 0.875rem;
    font-weight: 700;
  }

  .closed {
    color: #219653;
    opacity: 0.93;
  }

  .open {
    color: #f2c94c;
    opacity: 0.93;
  }
}
</style>
